import { lazy } from 'react';

export const Accounts = lazy(() => import('@/Portal/Accounts/AccountTabs'));
